module.exports = __webpack_public_path__ + "static/img/karticekorisnikazip4.6900265.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/karticekorisnikazip4.png
// module id = jHWx
// module chunks = 0